module.exports = __webpack_public_path__ + "img/logo-icon-white.c66e123d.png";